import namespacedStorage from './namespaced-storage'
import { useRestaurant } from '../components/RestaurantProvider/RestaurantProvider'
import { useOutpost } from '../components/OutpostProvider/OutpostProvider'
import { useMemo } from 'react'

export const useRestaurantStorage = () => {
  const { restaurantGuid } = useRestaurant()
  const { isOutpost } = useOutpost()

  const restaurantStorage = useMemo(() => {
    const namespace = isOutpost ? 'toast-oo-outpost' : 'toast-oo-restaurant'
    const storage = namespacedStorage(namespace)
    return {
      get: key => storage.get([restaurantGuid, key]),
      set: (key, value) => storage.set([restaurantGuid, key], value),
      remove: key => storage.remove([restaurantGuid, key])
    }
  }, [isOutpost, restaurantGuid])

  if (!restaurantGuid) throw new Error('Outside of Restaurant Context')
  return restaurantStorage
}
